export default __webpack_public_path__ + "static/media/616.5839eeb9.png";